export const ALLERGEN_MAP: Record<string, string> = {
  // Allergene
  A1: 'Glutenhaltig – Weizen',
  A2: 'Glutenhaltig – Roggen',
  A3: 'Glutenhaltig – Gerste',
  A4: 'Glutenhaltig – Dinkel',
  A5: 'Glutenhaltig – Hafer',
  B:  'Krebstiere',
  C:  'Eier und Eiererzeugisse',
  D:  'Fisch und Fischerzeugnisse',
  E:  'Erdnüsse und Erdnusserzeugnisse',
  F:  'Soja und Sojaerzeugnisse',
  G:  'Milch und Milcherzeugnisse',
  H:  'Schalenobst (Nüsse)',
  I:  'Sellerie und Sellerieerzeugnisse',
  J:  'Senf und Senferzeugnisse',
  K:  'Sesamsamen',
  L:  'Schwefeldioxid und Sulfide',
  M:  'Lupinen',
  N:  'Weichtiere (Schnecken, Muscheln, Kalmare, Austern)',
  P:  'Pilze',
  // Zusatzstoffe
  '1':  'mit Süßungsmittel',
  '2':  'mit Farbstoff',
  '3':  'mit Konservierungsmittel',
  '4':  'mit Phosphat',
  '5':  'mit Antioxidationsmittel',
  '6':  'mit Geschmacksverstärker',
  '7':  'geschwefelt',
  '8':  'chininhaltig',
  '9':  'coffeinhaltig',
  '10': 'mit Schweinefleisch',
};

export function formatAllergens(allergens: string[]): string {
  if (!allergens || allergens.length === 0) return '';
  return allergens.join(', ');
}

export function getAllergenLabel(code: string): string {
  return ALLERGEN_MAP[code] || code;
}

export const PICKUP_CODE_REGEX = /^\d[A-Z]\d[A-Z]$/;

export function validatePickupCode(code: string): boolean {
  return PICKUP_CODE_REGEX.test(code.toUpperCase());
}
